import React, { RefObject, useCallback, useRef, useState } from 'react';
import './RequiredLoansSelector.scss';
import { RenewalType } from '../../shop/renewals/utils/renewalTableTileTypes';
import MaterialIcon from './MaterialIcon';
import { formatRenewalType } from '../../shop/renewals/utils/formatRenewalType';
import { Button, ButtonSize, ButtonTheme } from './Button';
import { Popup, PopupTheme } from '../components/Popup/Popup';
import { useTranslation } from 'react-i18next';

export const RequiredLoansSelector = ({ changeRequiredLoan }: { changeRequiredLoan: (type: RenewalType) => void }) => {
    const toggleRef = useRef<HTMLElement>(null);
    const [expanded, setExpanded] = useState(false);
    const { t } = useTranslation();
    const types = Object.values(RenewalType).filter(
        type => type !== RenewalType.ALREADY_RENEWED && type !== RenewalType.UNAVAILABLE
    );

    const handleClose = useCallback(() => {
        setExpanded(false);
    }, []);

    return (
        <div className="required-loans-selector">
            <Button
                ref={toggleRef as RefObject<HTMLButtonElement>}
                size={ButtonSize.SMALL}
                theme={ButtonTheme.NEUTRAL}
                text={t('shop.subscriptions.changeRequiredLoans')}
                title={t('shop.subscriptions.changeRequiredLoans')}
                onClick={() => setExpanded(it => !it)}
                icon={'swap_vert'}
            />
            <Popup
                target={toggleRef}
                visible={expanded}
                placement="bottom-start"
                gap={0}
                arrow={false}
                onClose={handleClose}
                portal={false}
                theme={PopupTheme.LIGHT}
            >
                {types.map(type => (
                    <button
                        key={type}
                        onClick={() => {
                            changeRequiredLoan(type);
                            setExpanded(!expanded);
                        }}
                    >
                        <MaterialIcon icon="swap_vert" primary={true} />
                        {t(`components.requiredLoansSelector.${formatRenewalType(type)}`)}
                    </button>
                ))}
            </Popup>
        </div>
    );
};
